$(function () {
    // GardenSpot
    dataLayerGardenFormTracker('add-garden-spot-form', 'AddGardenSpot', 'Added GardenSpot');
    dataLayerGardenFormTracker('edit-garden-spot-form', 'EditGardenSpot', 'Edit GardenSpot');
    dataLayerGardenFormTracker('remove-garden-spot-form', 'RemoveGardenSpot', 'Remove GardenSpot');
    // PlantType
    dataLayerGardenFormTracker('add-plant-type-form', 'AddPlantType', 'Added PlantType', 'From Garden');
    dataLayerGardenFormTracker('edit-plant-type-form', 'EditPlantType', 'Edit PlantType');
    dataLayerGardenFormTracker('remove-plant-type-form', 'RemovePlantType', 'Remove PlantType');
    // Plant
    dataLayerGardenFormTracker('add-plant-form', 'AddPlant', 'Added Plant');
    // Plant with new PlantType
    dataLayerGardenFormTracker('add-plant-and-plant-type-form', 'AddPlantAndPlantType', 'Added Plant');
    dataLayerGardenFormTracker('add-plant-and-plant-type-form', 'AddPlantAndPlantType', 'Added PlantType', 'From Plant');
    function dataLayerGardenFormTracker(formId, eventName, eventAction, eventLabel) {
        var form = $('#' + formId).first();
        if (form.length < 1) {
            return;
        }
        if (!form.is('form')) {
            return;
        }
        form.submit(function () {
            var dataLayerObj = {
                'event': 'MinVilla_' + eventName,
                'eventCategory': 'MV Garden',
                'eventAction': eventAction,
            };
            if (eventLabel) {
                dataLayerObj['eventLabel'] = eventLabel;
            }
            window['dataLayer'].push(dataLayerObj);
        });
    }
});
